var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "firtReappraisal",
      attrs: {
        inline: true,
        model: _vm.relevantReappraisalApplication,
        "label-width": "200px",
        size: "small"
      }
    },
    [
      _c("el-form-item", { attrs: { label: "Τύπος αίτησης" } }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.relevantReappraisalApplication.applicationType ===
              "reappraisal"
                ? "Επανεξέταση"
                : ""
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Εκπρόθεσμη" } }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.relevantReappraisalApplication.overdue ? "Ναι" : "Όχι") +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Αριθμός αίτησης" } }, [
        _vm._v(
          "\n    " + _vm._s(_vm.relevantReappraisalApplication.id) + "\n  "
        )
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Αριθμός Πρωτοκόλλου" } }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.relevantReappraisalApplication.protocol) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Τύπος απόφασης" } }, [
        _vm._v("\n    " + _vm._s(_vm.reappraisalDecisionType) + "\n  ")
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Υπεύθυνος Αντιπρόεδρος" } }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.relevantReappraisalAppl.designatedVicePresident.surname +
                " " +
                _vm.relevantReappraisalAppl.designatedVicePresident.surname
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("attached-documents", {
        attrs: {
          attachedDocumentsTable: _vm.attachedDocumentsTable,
          neededDocuments: _vm.relevantReappraisalApplication.neededDocuments,
          appId: _vm.relevantReappraisalApplication.id
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-588bf5f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588bf5f3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FirstReappraisal.vue
// module id = null
// module chunks = 